document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobilePanel = document.querySelector('[data-mobile-panel]');
  if (menuButton && mobilePanel) {
    menuButton.addEventListener('click', () => {
      const open = mobilePanel.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
    });
  }

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-main-image]');
    gallery.querySelectorAll('[data-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const next = thumb.getAttribute('data-image-src');
        if (!main || !next) return;
        main.src = next;
        gallery.querySelectorAll('[data-thumb]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-skin-section]').forEach((section) => {
    const input = section.querySelector('[data-skin-search]');
    const cards = [...section.querySelectorAll('[data-skin-card]')];
    const counter = section.querySelector('[data-skin-count]');
    if (!input) return;
    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const matches = !query || card.textContent.toLowerCase().includes(query);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      if (counter) counter.textContent = `${visible} shown`;
    });
  });

  document.querySelectorAll('[data-buy-scroll]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.querySelector('[data-product-form]');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
});
